import Modal from 'components/Modal'
import { COOKIE_CONFIG } from 'constants/cookies'
import { actions, selectors } from 'data'
import Cookies from 'js-cookie'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PairAnnouncement from 'scenes/Margin/PairAnnouncement'
import WhatsNew from 'scenes/Modal/WhatsNew'
import isEmbedded from 'utils/isEmbedded'

import TradeOnMobile from './TradeOnMobile'
import WelcomeModal from './WelcomeModal'

const isCookieSet = (key: string): boolean => {
  try {
    return !!Cookies.get(key)
  } catch (e) {
    return false
  }
}

const getArrayFromCookie = (key: string): string[] => {
  try {
    return Cookies.get(key).split(',')
  } catch (e) {
    return []
  }
}

const OnBootMessages = () => {
  const user = useSelector(selectors.auth.getUser)
  const isAuthing = useSelector(selectors.auth.isAuthing)
  const [dismissed, setDismissed] = useState(false)
  const config = useSelector(selectors.config.getConfig)
  const balances = useSelector(selectors.balance.getAll)
  const orders = useSelector(selectors.historical.getOrders)
  const isLoadingOrders = useSelector(selectors.historical.getIsLoadingOrders)
  const onDismiss = () => setDismissed(true)
  const dispatch = useDispatch()
  useEffect(
    function fetchOrders() {
      if (!user) return
      dispatch(actions.historical.getOrders())
    },
    [user]
  )

  if (isEmbedded() || dismissed || isAuthing) return null

  const seenTradOnMobile = !!localStorage.getItem('promo-trade-on-mobile')
  const promoEndDate = new Date('2022-09-01')
  const now = new Date()
  if (!seenTradOnMobile && promoEndDate > now) {
    return (
      <TradeOnMobile
        onClose={() => {
          localStorage.setItem('promo-trade-on-mobile', '1')
          onDismiss()
        }}
      />
    )
  }

  // From here on, only modals for authed users
  if (!user || isLoadingOrders) return null

  // flow not dismissed in last 90d + no trade history + no balances
  const noTradeHistory = !orders.length
  const noBalances = !balances.length
  if (!isCookieSet('WelcomeDismissed') && noTradeHistory && noBalances) {
    return (
      <WelcomeModal
        onClose={() => {
          Cookies.set('WelcomeDismissed', 'true', COOKIE_CONFIG)
          onDismiss()
        }}
      />
    )
  }

  const { newMarginPairs } = config
  if (newMarginPairs.length > 0) {
    const seenMarginPairs = getArrayFromCookie('newMarginPairs')
    const firstUnseenMarginPair = newMarginPairs.find((c) => seenMarginPairs.indexOf(c) === -1)
    if (firstUnseenMarginPair) {
      const onClose = () => {
        const newPairs = [...seenMarginPairs, firstUnseenMarginPair].join(',')
        Cookies.set('newMarginPairs', newPairs, COOKIE_CONFIG)
        onDismiss()
      }
      return (
        <Modal onClose={onClose}>
          <PairAnnouncement pair={firstUnseenMarginPair} onClose={onClose} />
        </Modal>
      )
    }
  }

  const { newCurrencies } = config
  if (newCurrencies.length > 0) {
    const seenCurrencies = getArrayFromCookie('whatsNewModal')
    const firstUnseen = newCurrencies.find((c) => seenCurrencies.indexOf(c) === -1)
    if (firstUnseen) {
      const onClose = () => {
        const newSeens = [...seenCurrencies, firstUnseen].join(',')
        Cookies.set('whatsNewModal', newSeens, COOKIE_CONFIG)
        onDismiss()
      }
      return (
        <Modal onClose={onClose}>
          <WhatsNew currency={firstUnseen} onClose={onClose} />
        </Modal>
      )
    }
  }

  return null
}

export default OnBootMessages
